import {
  SignOutIcon,
  StorefrontIcon,
  SquaresFourIcon,
} from "@phosphor-icons/react";
import { ROUTES_LEGACY_WEBAPP } from "@payfac/constants";
import type { TFunction } from "i18next";
import type { DrawerItemProps } from "./header.type";

export const getDrawerItems = (
  t: TFunction,
  userEmail: string,
): DrawerItemProps[] => {
  const hasBOPermission = userEmail?.includes("@barte.com");

  const roles = {
    common: ["choose-company", "logout"],
    admin: ["choose-company", "backoffice", "logout"],
  };

  const role = hasBOPermission ? "admin" : "common";

  const allRoutes = [
    {
      key: "choose-company",
      label: t("payfac.headerChooseCompanyLink"),
      variant: "icon",
      icon: StorefrontIcon,
      link: ROUTES_LEGACY_WEBAPP.CHOOSE_COMPANY.fullPath,
    },
    {
      key: "backoffice",
      label: t("payfac.headerBackofficeLink"),
      variant: "icon",
      icon: SquaresFourIcon,
      link: ROUTES_LEGACY_WEBAPP.BACKOFFICE.fullPath,
    },
    {
      key: "logout",
      label: t("payfac.headerLogoutLink"),
      variant: "icon",
      icon: SignOutIcon,
      link: ROUTES_LEGACY_WEBAPP.LOGOUT.fullPath,
    },
  ];

  return allRoutes.filter((route) =>
    roles?.[role]?.includes(route.key),
  ) as DrawerItemProps[];
};
